<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <h1>Recent activity</h1>
      <div class="row">
        <!-- Card stats -->
        <div class="row col-lg-12">
          <div class="col-xl-3 col-lg-3">
            <stats-card
              title="Aaron Hadaway"
              type="gradient-green"
              sub-title="Rated you 5 stars"
              icon="ni ni-satisfied"
              class="mb-2 mb-xl-2"
            >
              <template slot="footer">
                "PG and his 8 year old son have been very pleasant people to
                work and chat with. Can only recommend."
              </template>
            </stats-card>
          </div>
          <div class="col-xl-3 col-lg-3">
            <stats-card
              title="Release launch"
              type="gradient-orange"
              sub-title="Two weeks earlier"
              icon="ni ni-chart-pie-35"
              class="mb-2 mb-xl-2"
            >
              <template slot="footer">
                <span class="text-success mr-2">
                  <i class="fa fa-arrow-up"></i> 12.18%
                </span>
                Good news! Your campuskraft team made incredible progress in
                your Asana backlog.
              </template>
            </stats-card>
          </div>
          <div class="col-xl-3 col-lg-3">
            <stats-card
              title="Aaron Hadaway"
              type="gradient-red"
              sub-title="You paid $380"
              icon="ni ni-money-coins"
              class="mb-2 mb-xl-2"
            >
              <template slot="footer">
                <span
                  >"Thanks Paul I really enjoyed working for you. Let me know if
                  there's anything else I can do for you."</span
                >
              </template>
            </stats-card>
          </div>
        </div>
        <div class="col-lg-12 mt-4">
          <h1>Your campuskraft</h1>
          <div class="row">
            <div class="col-xl-6 order-xl-2 mb-5 mb-xl-0">
              <div class="card card-profile shadow">
                <div class="row">
                  <div class="col-4">
                    <div class="row justify-content-center mt-3">
                      <a href="#">
                        <img
                          class="profile-pic"
                          height="172"
                          width="172"
                          src="img/theme/pic3.jpg"
                        />
                      </a>
                    </div>
                    <div class="text-center mt-2">
                      <h3>
                        Karl Hale<span class="font-weight-light">, online</span>
                      </h3>
                    </div>
                    <div
                      class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
                    >
                      <div class="d-flex justify-content-between">
                        <base-button size="sm" type="info" class="mr-4"
                          >Call</base-button
                        >
                        <base-button
                          size="sm"
                          type="default"
                          class="float-right"
                          >Message</base-button
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-8">
                    <h1 class="mt-2 primary">Market Analysis</h1>
                    <div class="table-responsive">
                      <base-table
                        class="table align-items-center table-flush task-table"
                        :class="type === 'dark' ? 'table-dark' : ''"
                        :thead-classes="
                          type === 'dark' ? 'thead-dark' : 'thead-light'
                        "
                        tbody-classes="list"
                        :data="tableData"
                      >
                        <template slot-scope="{ row }">
                          <th scope="row">
                            <div class="media align-items-center">
                              <div class="media-body">
                                <div v-if="row.status == 'Completed'">
                                  <input
                                    type="checkbox"
                                    checked="checked"
                                    onclick="return false;"
                                  /><span class="name mb-0 ml-3 text-sm">{{
                                    row.title
                                  }}</span>
                                </div>
                                <div v-else>
                                  <input
                                    type="checkbox"
                                    onclick="return false;"
                                  /><span class="name mb-0 ml-3 text-sm">{{
                                    row.title
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </th>
                          <td>
                            <badge
                              class="badge-dot ml-4 mr-4"
                              :type="row.statusType"
                            >
                              <i :class="`bg-${row.statusType}`"></i>
                              <span class="status">{{ row.status }}</span>
                            </badge>
                          </td>
                          <td class="budget">
                            {{ row.time }}
                          </td>
                          <td><p class="p-2"></p></td>
                        </template>
                      </base-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-6 order-xl-2 mb-5 mb-xl-0">
              <div class="card card-profile shadow">
                <div class="row">
                  <div class="col-4">
                    <div class="row justify-content-center mt-3">
                      <a href="#">
                        <img
                          class="profile-pic"
                          height="172"
                          width="172"
                          src="img/theme/pic2.jpg"
                        />
                      </a>
                    </div>
                    <div class="text-center mt-2">
                      <h3>
                        Claire Altman<span class="font-weight-light"
                          >, online</span
                        >
                      </h3>
                    </div>
                    <div
                      class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
                    >
                      <div class="d-flex justify-content-between">
                        <base-button size="sm" type="info" class="mr-4"
                          >Call</base-button
                        >
                        <base-button
                          size="sm"
                          type="default"
                          class="float-right"
                          >Message</base-button
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-8">
                    <h1 class="mt-2 primary">Forum Research</h1>
                    <div class="table-responsive">
                      <base-table
                        class="table align-items-center table-flush task-table"
                        :class="type === 'dark' ? 'table-dark' : ''"
                        :thead-classes="
                          type === 'dark' ? 'thead-dark' : 'thead-light'
                        "
                        tbody-classes="list"
                        :data="tableData2"
                      >
                        <template slot-scope="{ row }">
                          <th scope="row">
                            <div class="media align-items-center">
                              <div class="media-body">
                                <div v-if="row.status == 'Completed'">
                                  <input
                                    type="checkbox"
                                    checked="checked"
                                    onclick="return false;"
                                  /><span class="name mb-0 ml-3 text-sm">{{
                                    row.title
                                  }}</span>
                                </div>
                                <div v-else>
                                  <input
                                    type="checkbox"
                                    onclick="return false;"
                                  /><span class="name mb-0 ml-3 text-sm">{{
                                    row.title
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </th>
                          <td>
                            <badge
                              class="badge-dot ml-4 mr-4"
                              :type="row.statusType"
                            >
                              <i :class="`bg-${row.statusType}`"></i>
                              <span class="status">{{ row.status }}</span>
                            </badge>
                          </td>
                          <td class="budget">
                            {{ row.time }}
                          </td>
                          <td><p class="p-2"></p></td>
                        </template>
                      </base-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-xl-6 order-xl-2 mb-5 mb-xl-0">
              <div class="card card-profile shadow">
                <div class="row">
                  <div class="col-4">
                    <div class="row justify-content-center mt-3">
                      <a href="#">
                        <img
                          class="profile-pic"
                          height="172"
                          width="172"
                          src="img/theme/pic1.jpg"
                        />
                      </a>
                    </div>
                    <div class="text-center mt-2">
                      <h3>
                        Jessica Seibel<span class="font-weight-light"
                          >, offline</span
                        >
                      </h3>
                    </div>
                    <div
                      class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
                    >
                      <div class="d-flex justify-content-between">
                        <base-button size="sm" type="info" class="mr-4" disabled
                          >Call</base-button
                        >
                        <base-button
                          size="sm"
                          type="default"
                          class="float-right"
                          >Message</base-button
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-8">
                    <h1 class="mt-2 primary">Funding Research</h1>
                    <div class="table-responsive">
                      <base-table
                        class="table align-items-center table-flush task-table"
                        :class="type === 'dark' ? 'table-dark' : ''"
                        :thead-classes="
                          type === 'dark' ? 'thead-dark' : 'thead-light'
                        "
                        tbody-classes="list"
                        :data="tableData3"
                      >
                        <template slot-scope="{ row }">
                          <th scope="row">
                            <div class="media align-items-center">
                              <div class="media-body">
                                <div v-if="row.status == 'Completed'">
                                  <input
                                    type="checkbox"
                                    checked="checked"
                                    onclick="return false;"
                                  /><span class="name mb-0 ml-3 text-sm">{{
                                    row.title
                                  }}</span>
                                </div>
                                <div v-else>
                                  <input
                                    type="checkbox"
                                    onclick="return false;"
                                  /><span class="name mb-0 ml-3 text-sm">{{
                                    row.title
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </th>
                          <td>
                            <badge
                              class="badge-dot ml-4 mr-4"
                              :type="row.statusType"
                            >
                              <i :class="`bg-${row.statusType}`"></i>
                              <span class="status">{{ row.status }}</span>
                            </badge>
                          </td>
                          <td class="budget">
                            {{ row.time }}
                          </td>
                          <td><p class="p-2"></p></td>
                        </template>
                      </base-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-6 order-xl-2 mb-5 mb-xl-0">
              <div class="card card-profile shadow">
                <div class="row">
                  <div class="col-2"></div>
                  <div class="col-8 campuskraft-booking align-items-center">
                    <h1 class="primary">You need another helping hand?</h1>
                    <base-button type="default" @click="modals.modal0 = true"
                      >Book a campuskraft</base-button
                    >
                  </div>
                  <div class="col-2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </base-header>
    <modal
      :show.sync="modals.modal0"
      body-classes="p-0"
      modal-classes="modal-dialog-centered modal-lg"
    >
      <base-progress
        type="default"
        :height="16"
        :value="progress"
        showPercentage="false"
      ></base-progress>
      <card
        type="secondary"
        shadow
        header-classes="bg-white pb-5"
        body-classes="px-lg-5 py-lg-5"
        class="border-0"
      >
        <div v-if="loading">
          <template>
            <h1 class="text-center primary mb-5">campuskraft booking</h1>
            <h3 class="text-center m-5">Finding matches...</h3>
          </template>
        </div>
        <div v-else-if="!loading && !done">
          <template>
            <h1 class="text-center primary mb-5">campuskraft booking</h1>
            <div class="mb-5">
              <h2 class="primary">1. Candidate Profile</h2>
              <div class="row mb-4">
                <div class="col-4">Research Type:</div>
                <div class="col-8">
                  <base-dropdown>
                    <base-button
                      slot="title"
                      type="secondary"
                      class="dropdown-toggle"
                      v-model="selectedResearch"
                    >
                      {{ selectedResearch }}
                    </base-button>
                    <a
                      class="dropdown-item"
                      v-for="option in researchOptions"
                      :value="option"
                      :key="option"
                      @click="
                        selectedResearch = option;
                        progress += 10;
                      "
                    >
                      {{ option }}
                    </a>
                  </base-dropdown>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-4">Industry background:</div>
                <div class="col-8">
                  <base-dropdown>
                    <base-button
                      slot="title"
                      type="secondary"
                      class="dropdown-toggle"
                      v-model="selectedIndustry"
                    >
                      {{ selectedIndustry }}
                    </base-button>
                    <a
                      class="dropdown-item"
                      v-for="option in industryOptions"
                      :value="option"
                      :key="option"
                      @click="
                        selectedIndustry = option;
                        progress += 10;
                      "
                    >
                      {{ option }}
                    </a>
                  </base-dropdown>
                </div>
              </div>

              <div class="row">
                <div class="col-4">Preferred Experience:</div>
                <div class="col-8">
                  <base-dropdown>
                    <base-button
                      slot="title"
                      type="secondary"
                      class="dropdown-toggle"
                      v-model="selectedExperience"
                    >
                      {{ selectedExperience }}
                    </base-button>
                    <a
                      class="dropdown-item"
                      v-for="option in experienceOptions"
                      :value="option"
                      :key="option"
                      @click="
                        selectedExperience = option;
                        progress += 10;
                      "
                    >
                      {{ option }}
                    </a>
                  </base-dropdown>
                </div>
              </div>
            </div>
            <h2 class="primary">2. Project duration</h2>
            <div class="row mb-4">
              <div class="col-4">From when to when?</div>
              <div class="col-6">
                <base-input addon-left-icon="ni ni-calendar-grid-58">
                  <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="
                      focus;
                      progress += 30;
                    "
                    @on-close="blur"
                    :config="{ allowInput: true, mode: 'range' }"
                    class="form-control datepicker"
                    v-model="dates.range"
                  >
                  </flat-picker>
                </base-input>
              </div>
              <div class="col-4">
                How many hours per week?
              </div>
              <div class="col-4">
                <base-input
                  placeholder="15 hours"
                  @click="progress += 30"
                ></base-input>
              </div>
            </div>
          </template>
          <template>
            <div class="text-center">
              <base-button class="my-4" @click="matching"
                >Find your matching campuskraft</base-button
              >
            </div>
          </template>
        </div>
        <div v-if="!loading && done">
          <div>
            <div v-if="pagination.default == 1">
              <div class="row justify-content-center">
                <div
                  class="col-lg-3 mt-3"
                  style="margin-bottom: 64px !important"
                >
                  <div class="card-profile-image">
                    <a href="#">
                      <img src="img/theme/pic4.jpeg" class="rounded-circle" />
                    </a>
                  </div>
                </div>
                <div class="col-12">
                  <div
                    class="card-profile-stats d-flex justify-content-center mt-5"
                  >
                    <div>
                      <span class="heading">22</span>
                      <span class="description">Projects completed</span>
                    </div>
                    <div>
                      <span class="heading">4</span>
                      <span class="description">Months of experience</span>
                    </div>
                    <div>
                      <span class="heading">19</span>
                      <span class="description">Likes received</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row"></div>
              <div class="text-center">
                <h3>
                  Maurizio Blackwell<span class="font-weight-light">, 25</span>
                </h3>
              </div>
              <div class="text-center">
                <i class="ni education_hat mr-2"></i>Computer Science at, TUM in
                Munich
              </div>
              <hr class="my-4" />
              <p>
                In my bachelor thesis I quantified the German automotive market
                and since then focused on robotics in my master. Furthermore I
                developed an good eye for product design, when working at Nestle
                in Genf.
              </p>
              <base-button
                size="md"
                type="default"
                style="margin-left: 40%; margin-bottom: 64px"
                >Book Maurizio</base-button
              >
            </div>
          </div>
          <div v-if="pagination.default == 2">
            <div class="row justify-content-center">
              <div class="col-lg-3 mt-3" style="margin-bottom: 64px !important">
                <div class="card-profile-image">
                  <a href="#">
                    <img src="img/theme/pic6.jpeg" class="rounded-circle" />
                  </a>
                </div>
              </div>
              <div class="col-12">
                <div
                  class="card-profile-stats d-flex justify-content-center mt-5"
                >
                  <div>
                    <span class="heading">13</span>
                    <span class="description">Projects completed</span>
                  </div>
                  <div>
                    <span class="heading">2</span>
                    <span class="description">Months of experience</span>
                  </div>
                  <div>
                    <span class="heading">7</span>
                    <span class="description">Likes received</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row"></div>
            <div class="text-center">
              <h3>
                Sebastian Kraft<span class="font-weight-light">, 26</span>
              </h3>
            </div>
            <div class="text-center">
              <i class="ni education_hat mr-2"></i>Master of Philosophy at, RWTH
              in Aachen
            </div>
            <hr class="my-4" />
            <p>
              In my bachelor thesis I quantified the German food market and
              since then focused on philosophy in my master. Furthermore I
              developed an good eye for product design, when working at Nestle
              in Genf.
            </p>
            <base-button
              size="md"
              type="default"
              style="margin-left: 40%; margin-bottom: 64px"
              >Book Sebasitian</base-button
            >
          </div>
          <div v-if="pagination.default == 3">
            <div class="row justify-content-center">
              <div class="col-lg-3 mt-3" style="margin-bottom: 64px !important">
                <div class="card-profile-image">
                  <a href="#">
                    <img src="img/theme/pic5.jpeg" class="rounded-circle" />
                  </a>
                </div>
              </div>
              <div class="col-12">
                <div
                  class="card-profile-stats d-flex justify-content-center mt-5"
                >
                  <div>
                    <span class="heading">25</span>
                    <span class="description">Projects completed</span>
                  </div>
                  <div>
                    <span class="heading">7</span>
                    <span class="description">Months of experience</span>
                  </div>
                  <div>
                    <span class="heading">23</span>
                    <span class="description">Likes received</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row"></div>
            <div class="text-center">
              <h3>Claire Walls<span class="font-weight-light">, 23</span></h3>
            </div>
            <div class="text-center">
              <i class="ni education_hat mr-2"></i>Computer Science at, TUM in
              Munich
            </div>
            <hr class="my-4" />
            <p>
              In my bachelor thesis I quantified the German automotive market
              and since then focused on robotics in my master. Furthermore I
              developed an good eye for product design, when working at Nestle.
            </p>
            <base-button
              size="md"
              type="default"
              style="margin-left: 40%; margin-bottom: 64px"
              >Book Claire</base-button
            >
          </div>
          <base-pagination
            :page-count="3"
            v-model="pagination.default"
            align="center"
          ></base-pagination>
        </div>
      </card>
    </modal>
  </div>
</template>
<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: { flatPicker },
  data() {
    return {
      pagination: {
        default: 1,
      },
      loading: false,
      done: false,
      progress: 10,
      modals: {
        modal0: false,
      },
      selectedResearch: "Lead Research",
      researchOptions: [
        "Lead Research",
        "Competitior Analysis",
        "Trend Research",
        "Market Analysis",
        "SEO Analysis",
        "Data Wrangling",
        "Surveys",
      ],
      selectedExperience: "Junior",
      experienceOptions: ["Junior", "Mid-level", "Senior"],
      selectedIndustry: "Automobile",
      industryOptions: [
        "Automobile",
        "Banking",
        "Construction",
        "Consulting",
        "Energy",
        "Finance",
        "Food",
        "Human Resource",
        "IT and Services",
        "Marketing",
        "Retail",
        "Software",
      ],
      model: {
        username: "",
        email: "",
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        country: "",
        zipCode: "",
        about: "",
      },
      dates: {
        simple: "2020-09-15",
        range: "2020-09-15 to 2020-09-22",
      },
      tableData: [
        {
          title: "Prepare Excel Sheet",
          time: "02:36 h",
          status: "Completed",
          statusType: "success",
        },
        {
          title: "List missing US competitors",
          time: "03:28 h",
          status: "In progress",
          statusType: "info",
        },

        {
          title: "Sort by traction in first year",
          time: "",
          status: "Todo",
          statusType: "info",
        },
        {
          title: "Visualize unique selling points",
          time: "",
          status: "Todo",
          statusType: "info",
        },
      ],
      tableData2: [
        {
          title: "Interact with biology students",
          time: "12:36 h",
          status: "Completed",
          statusType: "success",
        },
        {
          title: "Cluster the reactions to the idea",
          time: "03:50",
          status: "Completed",
          statusType: "success",
        },
        {
          title: "A/B Test pitches to personas",
          time: "06:26",
          status: "in progress",
          statusType: "info",
        },
        {
          title: "Report your results to Gustaf",
          time: "",
          status: "Todo",
          statusType: "info",
        },
      ],
      tableData3: [
        {
          title: "Find matching programs",
          time: "02:36 h",
          status: "Completed",
          statusType: "success",
        },
        {
          title: "List all the requirements",
          time: "",
          status: "Todo",
          statusType: "info",
        },
        {
          title: "Present the results by Friday",
          time: "",
          status: "Todo",
          statusType: "info",
        },
      ],
    };
  },
  methods: {
    matching() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.done = true;
      }, 3400);
    },
  },
};
</script>
<style lang="scss" scoped>
.progress-wrapper {
  position: relative;
  padding-top: 0px !important;
  margin-top: -8px;
}
h1 {
  color: #fff;
}
.primary {
  color: #32325d;
}
.bg-gradient-success {
  background: linear-gradient(87deg, #ff6163 0, #ff9491 100%) !important;
}
.campuskraft-booking {
  height: 304px;
  h1 {
    margin-top: 25%;
  }
  button {
    margin-top: 8px;
    margin-left: 27.5%;
  }
}
.card .table td,
.card .table th {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.profile-pic {
  border-radius: 4px;
}
</style>
